import {_} from 'vue-underscore';
import Vue from 'vue';
import api from "../utils/api.js";
import events from "../utils/events.js";
import { OUTFIT_TYPES } from '../../config.js';

export const quizzes = {
    namespaced:true,
    state: {
        outfits: [],
        profile: {},
        current: {},
        currentOutfitIndex: 0,
        loadingProfile: false,
        loadingOutfits: false,
    },
    getters: {
        outfits(state){
            return state.outfits;
        },
        profile(state){
            return state.profile;
        },
        current(state){
            return state.current;
        },
        lastSentence(state) {
            return state.profile.quiz_taked && state.profile.quiz_taked.sentence;
        },
        currentOutfit(state) {
            return state.outfits[state.currentOutfitIndex];
        },
        currentOutfitIndex(state) {
            return state.currentOutfitIndex;
        },
        loadingProfile(state) {
            return state.loadingProfile;
        },
        loadingOutfits(state) {
            return state.loadingOutfits;
        },
    },
    mutations: {
        setProfile(state, profile){
            state.profile = profile;
        },
        setLoadingProfile(state, status) {
            state.loadingProfile = status;
        },
        setLoadingOutfits(state, status) {
            state.loadingOutfits = status;
        },
        setCurrent(state, quiz){
            state.current = quiz;
        },
        setCurrentOutfit(state, index) {
            state.currentOutfitIndex = index;
        },
        setOutfits(state, outfits){
            state.currentOutfitIndex = 0;
            state.outfits = outfits.map(outfit => ({
                ...outfit,
                currentProductIndex: 0,
                type: OUTFIT_TYPES.QUIZ,
            }));
        },
        changeOutfitProduct(state, payload) {
            const { index: productIndex, product, outfitId } = payload;
            const outfitIndex = state.outfits.findIndex(outfit => outfit.outfit_id === outfitId);
            const { products } = state.outfits[outfitIndex];
            
            products.splice(
                productIndex,
                1,
                product,
            );
            
            Vue.set(state.outfits[outfitIndex], 'products', products);
        },
        changeCurrentProduct(state, payload) {
            const { currentProductIndex, outfitId } = payload;
            let { outfitIndex } = payload;

            if(outfitIndex == undefined) outfitIndex = state.outfits.findIndex(outfit => outfit.outfit_id === outfitId);
            const outfitFromState = state.outfits[outfitIndex];

            state.outfits.splice(
                outfitIndex,
                1,
                {
                    ...outfitFromState,
                    currentProductIndex,
                },
            );
        },
    },
    actions: {
        fetchOutfits(context) {
            if(context.state.loadingOutfits) return;

            context.commit('setLoadingOutfits', true);

            const uri = api.outfitsUri() + '/quiz';
            return api
                .get(uri, {
                    params: {
                        quiz_id: context.state.current.quiz_id || '',
                    }
                })
                .then(response => {
                    context.commit('setOutfits', response.outfits);
                    
                    return response.outfits;
                })
                .catch((err) =>{ throw err })
                .finally(() => {
                    context.commit('setLoadingOutfits', false);
                });
        },
        fetchQuizProfile(context, reset) {
            if(!reset && context.state.loadingProfile) return;

            const uri = api.accountUri() + 'quiz-profile';

            context.commit('setLoadingProfile', true);
            
            return api
                .get(uri)
                .then(response => {
                    context.commit('setProfile', response);
                    
                    return response;
                })
                .catch((err) =>{ throw err })
                .finally(() => {
                    context.commit('setLoadingProfile', false);
                });
        }
    }
};